import { Radar } from "lucide-react";
import { cn } from "../lib/cn";

export function Logo({
  withWordmark = true,
  className,
}: {
  withWordmark?: boolean;
  className?: string;
}) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <div className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-brand to-brand-dim shadow-soft">
        <Radar size={18} className="text-white" />
      </div>
      {withWordmark && (
        <span className="text-[15px] font-bold tracking-tight text-ink">
          Biedradar <span className="font-semibold text-ink-muted">Pro</span>
        </span>
      )}
    </div>
  );
}
